// extracted by mini-css-extract-plugin
module.exports = {"buttons":"InventoryAccessories_buttons__2w0AW"};